var React = require('react');

function Chart (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icon / chart"),React.createElement("g",{"id":"icon-/-chart","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Group-3"},[React.createElement("rect",{"id":"Rectangle-Copy","fill":"#FFFFFF","x":"0","y":"0","width":"44","height":"44","rx":"22","key":0}),React.createElement("g",{"id":"Group-2","className":"colorable","transform":"translate(12.000000, 13.500000)","fill":"#24242C","key":1},React.createElement("path",{"d":"M6.66666667,16 L6.66666667,18 L0,18 L0,16 L6.66666667,16 Z M10,12 L10,14 L0,14 L0,12 L10,12 Z M13.3333333,8 L13.3333333,10 L0,10 L0,8 L13.3333333,8 Z M16.6666667,4 L16.6666667,6 L0,6 L0,4 L16.6666667,4 Z M20,0 L20,2 L0,2 L0,0 L20,0 Z","id":"Combined-Shape"}))]))]);
}

Chart.defaultProps = {"width":"44px","height":"44px","viewBox":"0 0 44 44","version":"1.1"};

module.exports = Chart;

Chart.default = Chart;
